import Styles from './BrandWizardVisualAnalysisModal.module.scss'
import { Text } from 'blaze-ui/Text/Text'

interface ShimmeringColorProps {
  aspectRatio: number
  width?: number | string
  height?: number | string
  borderRadius?: number | string
}

export const ShimmeringColor = ({ aspectRatio, width, height, borderRadius }: ShimmeringColorProps) => (
  <div className={Styles.shimmeringColor} style={{ aspectRatio, width, height, borderRadius }} />
)

export const ShimmeringFont = ({ label, height, width }: { label: string; height: number; width: number }) => (
  <div className={Styles.font}>
    <div className={Styles.fontSidebar}>
      <Text variant="placeholder" color="var(--dark-40)">
        {label}
      </Text>
    </div>
    <div className={Styles.fontPreview}>
      <div className={Styles.shimmeringFont} style={{ width, height }} />
    </div>
  </div>
)
